var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-mobile-full-screen-container", [
    _c(
      "div",
      { staticClass: "w100" },
      [
        _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
        _c(
          "w-scroll-view",
          { attrs: { tag: "w-container" } },
          [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { xs: "12", md: "6" } },
                  [
                    _vm.hasModule
                      ? _c(
                          "w-card",
                          [
                            _c("w-card-title", [
                              _vm._v(_vm._s(_vm.$ct("title"))),
                            ]),
                            _c(
                              "w-card-content",
                              [
                                !_vm.config.Connected
                                  ? [
                                      _c(
                                        "w-row",
                                        [
                                          _c(
                                            "w-col",
                                            { attrs: { xs: "12" } },
                                            [
                                              _c(
                                                "w-button",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.requestingToken,
                                                    icon: "envelope",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.requestToken()
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        _vm.$ct("request-token")
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _vm.tokenSentEmail
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "status connected",
                                                      staticStyle: {
                                                        "margin-top": "8px",
                                                      },
                                                    },
                                                    [
                                                      _c("w-fa", {
                                                        attrs: {
                                                          icon: "check-circle",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "token-sent",
                                                              {
                                                                email:
                                                                  _vm.tokenSentEmail,
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-col",
                                            { attrs: { xs: "12" } },
                                            [
                                              _c("w-input", {
                                                attrs: {
                                                  label: _vm.$ct("token"),
                                                  fancy: "",
                                                },
                                                model: {
                                                  value: _vm.token,
                                                  callback: function ($$v) {
                                                    _vm.token = $$v
                                                  },
                                                  expression: "token",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "hint" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("token-hint")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "w-col",
                                            { attrs: { xs: "12" } },
                                            [
                                              _c("w-date-picker", {
                                                attrs: {
                                                  label: _vm.$ct("start-date"),
                                                  fancy: "",
                                                },
                                                model: {
                                                  value: _vm.config.StartDate,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.config,
                                                      "StartDate",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "config.StartDate",
                                                },
                                              }),
                                              _c(
                                                "small",
                                                { staticClass: "hint" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$ct("start-date-hint")
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "w-row",
                                        [
                                          _c("w-col", { attrs: { xs: "12" } }, [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "status connected",
                                              },
                                              [
                                                _c("w-fa", {
                                                  attrs: {
                                                    icon: "check-circle",
                                                  },
                                                }),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$ct("connected")
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                _c(
                                  "w-row",
                                  [
                                    _c(
                                      "w-col",
                                      { attrs: { xs: "12" } },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "document-types-title",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$ct("document-types"))
                                            ),
                                          ]
                                        ),
                                        _c("w-checkbox", {
                                          attrs: {
                                            label: _vm.$ct("fetch-coda"),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.saveDocumentTypes()
                                            },
                                          },
                                          model: {
                                            value: _vm.config.FetchCoda,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "FetchCoda",
                                                $$v
                                              )
                                            },
                                            expression: "config.FetchCoda",
                                          },
                                        }),
                                        _c("w-checkbox", {
                                          attrs: {
                                            label: _vm.$ct("fetch-soda"),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.saveDocumentTypes()
                                            },
                                          },
                                          model: {
                                            value: _vm.config.FetchSoda,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "FetchSoda",
                                                $$v
                                              )
                                            },
                                            expression: "config.FetchSoda",
                                          },
                                        }),
                                        _c("w-checkbox", {
                                          attrs: {
                                            label: _vm.$ct(
                                              "fetch-purchase-invoices"
                                            ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.saveDocumentTypes()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.config.FetchPurchaseInvoices,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "FetchPurchaseInvoices",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "config.FetchPurchaseInvoices",
                                          },
                                        }),
                                        _c("w-checkbox", {
                                          attrs: {
                                            label: _vm.$ct(
                                              "fetch-sales-invoices"
                                            ),
                                          },
                                          on: {
                                            input: function ($event) {
                                              return _vm.saveDocumentTypes()
                                            },
                                          },
                                          model: {
                                            value:
                                              _vm.config.FetchSalesInvoices,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "FetchSalesInvoices",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "config.FetchSalesInvoices",
                                          },
                                        }),
                                        _c("small", { staticClass: "hint" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$ct("document-types-hint")
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            ),
                            _c(
                              "w-card-actions",
                              [
                                !_vm.config.Connected
                                  ? [
                                      _c("w-spacer"),
                                      _c(
                                        "w-button",
                                        {
                                          attrs: {
                                            disabled:
                                              !_vm.token || _vm.connecting,
                                            icon: "link",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.connect()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$ct("connect")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "w-button",
                                        {
                                          staticClass: "cancel",
                                          attrs: { icon: "unlink" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.disconnect()
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$ct("disconnect")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _c("app-missing-module", {
                          attrs: { "module-id": _vm.mod },
                        }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }